module.exports = __webpack_public_path__ + "img/预留洗手池.10c70aaa.webp";